import { render, staticRenderFns } from "./service.vue?vue&type=template&id=23972249&scoped=true"
import script from "./service.vue?vue&type=script&lang=js"
export * from "./service.vue?vue&type=script&lang=js"
import style0 from "./service.vue?vue&type=style&index=0&id=23972249&prod&lang=scss&scoped=true"
import style1 from "./service.vue?vue&type=style&index=1&id=23972249&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23972249",
  null
  
)

export default component.exports